import { getProps } from '../props';

export default (id) => async () => {
  const { onClose, didSelectValuation } = getProps();

  if(didSelectValuation) didSelectValuation(id);

  onClose();

}